import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Column, FullColumn, FullRow, Typography, WithInfoIcon } from 'seagull';
import { PaymentTerms } from 'seagull/icons';
import { useFeatureFlags } from '~/hooks/useFeatureFlags';
import { Service } from '../Service';
import { BillingSchedule } from './BillingSchedule/BillingSchedule';
export const ReviewServicesV2 = (param)=>{
    let { services, nonOptionalServices, optionalServices, relationship, selectedOptionalServices, selectedBundleId, setSelectedOptionalServices } = param;
    const { RM_BILLING_SUMMARY } = useFeatureFlags();
    if (services.length === 0) {
        return /*#__PURE__*/ _jsxs(FullColumn, {
            gap: 16,
            children: [
                /*#__PURE__*/ _jsxs(FullRow, {
                    gap: 12,
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ _jsx(PaymentTerms, {}),
                        /*#__PURE__*/ _jsx(Typography, {
                            variant: "h6",
                            weight: "normal",
                            children: "Services"
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(Typography, {
                    skin: "secondary",
                    children: "Once a package is selected, services will appear here"
                })
            ]
        });
    }
    return /*#__PURE__*/ _jsxs(FullColumn, {
        gap: 24,
        children: [
            /*#__PURE__*/ _jsxs(Column, {
                gap: 16,
                children: [
                    /*#__PURE__*/ _jsxs(FullRow, {
                        gap: 12,
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ _jsx(PaymentTerms, {}),
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "h6",
                                weight: "normal",
                                children: "Services"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(Column, {
                        gap: 16,
                        children: [
                            nonOptionalServices.map((service, i)=>/*#__PURE__*/ _jsx(Service, {
                                    idx: i,
                                    relationship: relationship,
                                    service: service
                                })),
                            !!optionalServices.length && /*#__PURE__*/ _jsx(WithInfoIcon, {
                                info: "Services in this section are optional. Only the services selected will be added to your agreement",
                                children: /*#__PURE__*/ _jsx(Typography, {
                                    children: "Additional services to choose from"
                                })
                            }),
                            optionalServices.map((service, i)=>/*#__PURE__*/ _jsx(Service, {
                                    idx: i + nonOptionalServices.length,
                                    relationship: relationship,
                                    service: service,
                                    optionallySelected: selectedOptionalServices.includes(service.id),
                                    onChangeOptionallySelected: (selected)=>{
                                        const newSelected = selected ? selectedOptionalServices.concat(service.id) : selectedOptionalServices.filter((id)=>id !== service.id);
                                        setSelectedOptionalServices(newSelected);
                                    }
                                }))
                        ]
                    })
                ]
            }),
            !RM_BILLING_SUMMARY && /*#__PURE__*/ _jsx(BillingSchedule, {
                services: services,
                serviceBundles: relationship.serviceBundles,
                effectiveDate: relationship.effectiveDate,
                selectedOptionalServices: selectedOptionalServices,
                selectedBundleId: selectedBundleId
            })
        ]
    });
};
